var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShown)?_c('span',[_vm._v("("+_vm._s(_vm.$t('Components.PriceTax.tax_included'))+")")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }